<template>
  <el-dialog
    top="5vh"
    :visible.sync="showDialog"
    width="870px"
    class="ParamsDialog"
    title="设置筛选条件"
  >
    <el-form ref="form" :model="form" label-width="120px" class="el_form">
      <div class="long_form_item_box">
        <el-form-item label="查询时间：">
          <el-date-picker
            v-model="timeSlot"
            :size="formSize"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </div>
      <!-- 左边筛选条件 开始 -->
      <div class="form_item_box">
        <el-form-item label="姓名">
          <el-input v-model="form.name" placeholder="姓名" :size="formSize" />
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.mobile" placeholder="电话" :size="formSize" />
        </el-form-item>
        <el-form-item label="跟进记录">
          <el-input v-model="form.remark" placeholder="跟进记录" :size="formSize" />
        </el-form-item>
        <el-form-item label="资质">
          <field-select ref="fieldSelect" :form="form" />
        </el-form-item>
        <el-form-item label="星级标签">
          <label-select v-model="form.label" placeholder="请选择星级标签" />
        </el-form-item>
        <el-form-item label="跟进状态">
          <follow-status v-model="form.progress" />
        </el-form-item>
        <el-form-item label="未跟进天数">
          <el-input
            placeholder="未跟进天数"
            :size="formSize"
            v-model="form.days"
          ></el-input>
        </el-form-item>
        <el-form-item label="跟进次数" v-if="remarkCount">
          <el-input
            placeholder="跟进次数"
            :size="formSize"
            v-model="form.remarkCount"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否公共池客户" v-if="publicPool">
          <el-select
            v-model="form.publicPool"
            :size="formSize"
            placeholder="是否公共池客户"
          >
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </el-form-item>
      </div>
      <!-- 左边筛选条件 end -->
      <!-- 右边筛选条件 开始 -->
      <div class="form_item_box">
        <el-form-item label="媒体">
          <media-select
            v-model="form.media"
            :size="formSize"
            multiple
            collapse-tags
          />
        </el-form-item>
        <el-form-item label="渠道">
          <channel-select
            v-model="form.channels"
            :size="formSize"
            multiple
            collapse-tags
          />
        </el-form-item>
        <el-form-item label="城市">
          <el-input v-model="form.city" placeholder="城市" :size="formSize" />
        </el-form-item>
      </div>
      <!-- 右边筛选条件 end -->
    </el-form>
    <div class="btn d-flex">
      <el-button @click="resetForm">重置查询条件</el-button>
      <el-button
        icon="el-icon-search"
        class="smallBorderRadius"
        type="primary"
        @click="search"
        >查询</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import {
  followUpOptions,
  startOptions,
  passOptions,
  effectiveOptions,
} from "./config";
import { shopList, allTeamList, getEmployee } from "@/api/customer";
import { getAllChannelList } from "@/api/channel/index";
import { mapState } from "vuex";
import { GETCUSTOMERSTATUS } from "@/api/customer";
import LabelSelect from "@/components/labels";
import FollowStatus from "@/components/follow/status";
export default {
  components: {
    LabelSelect,
    FollowStatus,
  },
  props: {
    visible: {
      type: Boolean,
    },
    remarkCount: {
      type: Boolean,
    },
    publicPool: {
      type: Boolean,
    },
  },
  data() {
    return {
      followUpOptions,
      startOptions,
      passOptions,
      effectiveOptions: effectiveOptions,
      timeSlot: "",
      form: {
        level: "",
        call: "",
        fit: "",
        progress: "",
        city: "",
        name: "",
        mobile: "",
        publicPool: "",
        followDayCount: "",
      },
      fieldList: [],
      shopId: "",
      teamId: "",
      employeeId: "",
      channelId: "",
      shopOptionList: [],
      teamOptionList: [],
      employeeOptionList: [],
      channelList: [],
      teamSelectLoading: false,
      employeeSelectLoading: false,
      formSize: "small",
      statusList: [],
    };
  },
  computed: {
    ...mapState({
      fieldList1: (state) => state.myClient.fieldList,
    }),
    showDialog: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val); // visible 改变的时候通知父组件
      },
    },
  },
  watch: {
    fieldList1(val) {
      this.fieldList = JSON.parse(JSON.stringify(val));
    },
  },
  mounted() {
    this.shopList();
    this.getAllChannelList();
    this.search();
    this.fieldList = JSON.parse(JSON.stringify(this.fieldList1));
  },
  methods: {
    shopList() {
      shopList().then((res) => {
        this.shopOptionList = res.data;
      });
    },
    async shopSelectChange() {
      this.teamSelectLoading = true;
      this.teamId = "";
      this.employeeId = "";
      try {
        await allTeamList({ shopId: this.shopId }).then((res) => {
          this.teamOptionList = res.data || [];
        });
        this.teamSelectLoading = false;
      } catch (error) {
        this.teamSelectLoading = false;
      }
    },
    async teamSelectChange() {
      this.employeeSelectLoading = true;
      this.employeeId = "";
      try {
        await getEmployee({ shopId: this.shopId, teamId: this.teamId }).then(
          (res) => {
            this.employeeOptionList = res.data || [];
          }
        );
        this.employeeSelectLoading = false;
      } catch (error) {
        this.employeeSelectLoading = false;
      }
    },
    search() {
      const form = Object.assign(
        {
          shopId: this.shopId,
          teamId: this.teamId,
          employeeId: this.employeeId,
          channelId: this.channelId,
        },
        this.form
      );
      this.fieldList.forEach((element, index) => {
        form["field" + (index + 1)] = element.value1;
      });
      if (this.timeSlot) {
        form.startDate = this.timeSlot[0];
        form.endDate = this.timeSlot[1];
      }
      this.showDialog = false;
      this.$emit("search", form);
    },
    resetForm() {
      for (const key in this.form) {
        if (Object.hasOwnProperty.call(this.form, key)) {
          this.form[key] = "";
        }
      }
      this.timeSlot = "";
      this.fieldList.forEach((element) => {
        element.value1 = "";
      });
      this.shopId = "";
      this.teamId = "";
      this.employeeId = "";
      this.$refs.fieldSelect.rest();
      this.search();
    },
    async getAllChannelList() {
      try {
        await getAllChannelList().then((res) => {
          this.channelList = res.data;
        });
      } catch (error) {}
    },
    // 获取状态
    getStatus() {
      GETCUSTOMERSTATUS().then((res) => {
        this.statusList = res.data || [];
      });
    },

    // 设置参数
    setParams(id, value) {
      this.$set(this.form, id, value);
    },
  },
};
</script>
<style lang="scss" scoped>
.el_form {
  display: flex;
  flex-wrap: wrap;
  .form_item_box {
    flex: 0 0 50%;
  }
  .long_form_item_box {
    flex: 0 0 100%;
  }
}
.params {
  padding-top: 20px;
  .params_list {
    display: flex;
    justify-content: space-between;
  }
  .wrapping {
    display: inline-block;
    margin-bottom: 10px;
    width: 49%;
    margin-right: 0;
  }
}
.btn {
  justify-content: flex-end;
  margin-right: 80px;
}
</style>
